<ion-content>
  <ion-grid class="box">
    <ion-row class="content-padding-vertical" justify-content-center>
      <ion-col>
        <div class="header">
          <h2>Akceptacja dostępu dla gościa / Accept access for guest</h2>
        </div>

        <div class="status" *ngIf="isClosed">
          <span [ngClass]="invitation.invitationGuests[0]?.accepted ? 'accepted' : 'rejected'">
            {{invitation.invitationGuests[0]?.accepted ? 'Zaakceptowane/Accepted' : 'Odrzucono/Rejected' }}
          </span>
        </div>

        <div class="row">
          <span class="label">
            Firma/Company:
          </span>
          <span class="value">
            <!-- {{ invitation.user.company.name }} -->
          </span>
        </div>

        <div class="row">
          <span class="label">
            Data/Date:
          </span>
          <span class="value">
            {{invitation?.formatedData}}
          </span>
        </div>

        <div class="guest-header">
          Gość/Guest
        </div>

        <div class="guest">

          <div class="row">
            <span class="value-bold">
              {{invitation.invitationGuests[0]?.fullname}}
            </span>
          </div>

          <div class="row">
            <span class="label">
              Email:
            </span>
            <span class="value">
              {{invitation.invitationGuests[0]?.email}}
            </span>
          </div>

          <div class="row">
            <span class="label">
              Telefon/Mobile:
            </span>
            <span class="value">
              {{invitation.invitationGuests[0]?.phoneNumber}}
            </span>
          </div>

        </div>


        <ion-item lines="none" *ngIf="!isClosed">
          <!-- <ion-button class="button-margin-top-md" size="small" (click)="onAcceptClick()" slot="end">Cancel</ion-button> -->
          <ion-button class="button-margin-top-md" size="medium" (click)="onAcceptClick()" slot="end">Akceptuj
          </ion-button>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>